import { ButtonBase, Dialog } from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    Header: {
        display: "flex",
    },
    ItemDesc: {
        display: "flex",
    },
    ItemDescImage: {
        position: "absolute",
        width: "90px",
        height: "69.38px",
        left: "18px",
        top: "76px",
        borderRadius: "8px",
    },
    ItemDescName: {
        position: "absolute",
        width: "73px",
        height: "17px",
        left: "120px",
        top: "84px",
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "17px",
        color: "#271D1C",
    },
    AddonsRaw: {
        display: "flex",
        alignItems: "center",
        // width: "50%",

        "& span": {
            marginLeft: "auto",
            "&:last-child": {
                marginRight: "2rem",
            },
        },
    },
    ItemDescPrice: {
        position: "absolute",
        width: "22px",
        height: "15px",
        right: "185px",
        top: "105px",
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "15px",
        textAlign: "center",
        color: "#271D1C",
        fontWeight: "bold",
        fontSize: "20px",
    },
    ItemQty: {
        position: "absolute",
        width: "146px",
        height: "51px",
        left: "391px",
        top: "85px",
        background: "#FFFFFF",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
    },
    ItemQtyMinus: {
        background: "#f5f6fa",
    },
    ItemQtyPlus: {
        background: "#6E7187",
        color: "white",
    },
    ItemQtyText: {
        width: "12px",
        height: "29px",
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "24px",
        lineHeight: "29px",
        textAlign: "center",
        color: "#271D1C",
    },
    Addons: {
        position: "absolute",
        width: "119px",
        height: "17px",
        left: "24px",
        top: "185.38px",
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "17px",
        textTransform: "uppercase",
        color: "#6E7187",
    },
    AddonsList: {
        boxSizing: "border-box",
        position: "absolute",
        width: "513px",
        height: "250px",
        left: "-2px",
        top: "26px",
        background: "#FFFFFF",
        border: "1px solid #e5e9f2",
        borderRadius: "8px",
        padding: "5px",
        // display: "flex",
        // flexFlow: "column",
        overflow: "auto",
    },
    Notes: {
        position: "absolute",
        width: "48px",
        height: "17px",
        left: "24px",
        top: "500px",
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "17px",
        textTransform: "uppercase",
        color: "#271D1C",
    },
    NotesArea: {
        position: "absolute",
        left: "24px",
        top: "525px",
        background: "rgba(251, 253, 245, 0.75)",
        borderRadius: "8px",
        width: "513px",
        height: "101px",
    },
    TotalText: {
        position: "absolute",
        width: "39px",
        height: "15px",
        left: "24px",
        top: "643px",
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "15px",
        textTransform: "uppercase",
        color: "#271D1C",
    },
    TotalPrice: {
        position: "absolute",
        width: "47px",
        height: "29px",
        left: "24px",
        top: "663px",
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "24px",
        lineHeight: "29px",
        textTransform: "uppercase",
        color: "#271D1C",
    },
    AddonsPrice: {
        position: "absolute",
        width: "101px",
        height: "15px",
        left: "79px",
        top: "673px",
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "15px",
        textTransform: "uppercase",
        color: "#6E7187",
    },
    DialogAction: {
        position: "absolute",
        width: "318px",
        height: "47px",
        left: "219px",
        top: "645px",
        background: "#6E7187",
        boxShadow:
            "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
        borderRadius: "8px",
        fontFamily: "'Inter'",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "12px",
        lineHeight: "15px",
        textAlign: "center",
        textTransform: "uppercase",
        color: "#FFFFFF",
    },
}));

export const ItemDialog = withStyles((theme) => ({
    paper: {
        width: "557px",
        height: "783px",
        background: "#f5f6fa",
    },
}))(Dialog);

export const ItemSmallButton = withStyles((theme) => ({
    root: {
        width: "28px",
        height: "28px",
        borderRadius: "6px",
    },
}))(ButtonBase);
